<pf-file-upload
        [uploadFiles]="displayFiles$ | async"
        [uploadInstructions]="environment.uploadInstructions"
        (filesSelected)="onFilesSelected($event)"
        (remove)="removeFile($event)"
        (openFile)="onOpenFile($event)"
></pf-file-upload>

@if (showError) {
    <pf-hinweisbox
            [boxType]="HinweisboxTypeEnum.ERROR"
            [boxTitle]="'sendmail.form.upload.delete-error-title' | i18next"
            boxId="delete">{{ 'sendmail.form.upload.delete-error-text' | i18next }}
    </pf-hinweisbox>
}

